// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Fmx0","colMin":"styles_colMin__1-X6H"};